import {
    PATCH_CALENDAR_EVENT_FORM,
    INCREASE_CALENDAR_EVENT_STEP,
    DECREASE_CALENDAR_EVENT_STEP,
    SET_CALENDAR_EVENT_STEP,
    RESET_CALENDAR_EVENT_FORM,
} from "./CalendarEventFormActionTypes"

export function patchCalendarEventForm(payload: object) {
    return {
        type: PATCH_CALENDAR_EVENT_FORM,
        payload: payload,
    }
}

export function increaseCalendarEventStep() {
    return {
        type: INCREASE_CALENDAR_EVENT_STEP,
    }
}

export function decreaseCalendarEventStep() {
    return {
        type: DECREASE_CALENDAR_EVENT_STEP,
    }
}

export function setCalendarEventStep(step: number) {
    return {
        type: SET_CALENDAR_EVENT_STEP,
        payload: {
            step: step,
        }
    }
}

export function resetCalendarEventForm() {
    return {
        type: RESET_CALENDAR_EVENT_FORM,
    }
}



// WEBPACK FOOTER //
// ./src/state/calendar-event/CalendarEventFormActions.ts